import { z } from "zod"

import {
  commandIdSchema,
  correlationIdSchema,
  entityIdSchema,
} from "./identifiers.js"

export const commandErrorCodeV1Schema = z.enum([
  "INVALID_COMMAND",
  "COMMAND_NOT_SUPPORTED",
  "COMMAND_DENIED",
  "COMMAND_FAILED",
  "VERSION_CONFLICT",
  "INVALID_STATE_TRANSITION",
  "IDEMPOTENCY_CONFLICT",
])

export const safeEntitySummaryV1Schema = z
  .object({
    entityType: z.string().regex(/^[a-z][a-z0-9_]{0,63}$/),
    entityId: entityIdSchema,
    state: z.string().min(1).max(32),
    version: z.number().int().nonnegative().safe(),
  })
  .strict()

export const commandErrorV1Schema = z
  .object({
    version: z.literal(1),
    code: commandErrorCodeV1Schema,
    retryable: z.boolean(),
    message: z.string().min(1).max(128),
    current: safeEntitySummaryV1Schema.optional(),
  })
  .strict()

const commandSuccessV1Schema = z
  .object({
    responseVersion: z.literal(1),
    ok: z.literal(true),
    commandId: commandIdSchema,
    correlationId: correlationIdSchema,
    result: z.record(z.string(), z.json()),
  })
  .strict()

const commandFailureV1Schema = z
  .object({
    responseVersion: z.literal(1),
    ok: z.literal(false),
    commandId: commandIdSchema.nullable(),
    correlationId: correlationIdSchema.nullable(),
    error: commandErrorV1Schema,
  })
  .strict()

export const commandResultV1Schema = z.discriminatedUnion("ok", [
  commandSuccessV1Schema,
  commandFailureV1Schema,
])

export type CommandErrorCodeV1 = z.infer<typeof commandErrorCodeV1Schema>
export type CommandErrorV1 = z.infer<typeof commandErrorV1Schema>
export type CommandResultV1 = z.infer<typeof commandResultV1Schema>
export type SafeEntitySummaryV1 = z.infer<typeof safeEntitySummaryV1Schema>
